/** @file fitChoice: whether a dropped image fills its slot as is or the user must pick pad / scale. */

/** `exact` when the image has the slot's size, else `ask` (offer Pad / Scale / Cancel, never upload blind). */
export function fitChoice(imageSize: readonly [number, number], slotSize: readonly [number, number]): 'exact' | 'ask' {
  return imageSize[0] === slotSize[0] && imageSize[1] === slotSize[1] ? 'exact' : 'ask';
}
